import { defineMessages } from 'react-intl';

export default defineMessages({
    availableDocuments: {
        id: 'ml.gateway.quoteandbind.common.availableDocuments.Available Documents',
        defaultMessage: 'Available Documents'
    },
    requiredDocuments: {
        id: 'ml.gateway.quoteandbind.common.availableDocuments.required Documents',
        defaultMessage: 'required documents'
    },
    allDocsSigned: {
        id: 'ml.gateway.quoteandbind.common.availableDocuments.allDocsSigned',
        defaultMessage: 'All the {requiredDocuments} must be signed in order to proceed'
    },
    followingDocuments: {
        id: 'ml.gateway.quoteandbind.common.availableDocuments.following documents',
        defaultMessage: 'following documents'
    },
    docsRetained: {
        id: 'ml.gateway.quoteandbind.common.availableDocuments.docsRetained',
        defaultMessage: 'The {followingDocuments} must be retained for your records.'
    },
    documents: {
        id: 'ml.gateway.quoteandbind.common.availableDocuments.Documents',
        defaultMessage: 'Documents'
    },
    signatureType: {
        id: 'ml.gateway.quoteandbind.common.availableDocuments.Signature Type',
        defaultMessage: 'Signature Type'
    },
    dateSigned: {
        id: 'ml.gateway.quoteandbind.common.availableDocuments.Date Signed',
        defaultMessage: 'Date Signed'
    },
    documentRetention: {
        id: 'ml.gateway.quoteandbind.common.availableDocuments.Document Retention',
        defaultMessage: 'Document Retention'
    },
    actions: {
        id: 'ml.gateway.quoteandbind.common.availableDocuments.Actions',
        defaultMessage: 'Actions'
    },
    view: {
        id: 'ml.gateway.quoteandbind.common.availableDocuments.View',
        defaultMessage: 'View'
    },
    viewEnglish: {
        id: 'ml.gateway.quoteandbind.common.availableDocuments.View English',
        defaultMessage: 'View English'
    },
    viewSpanish: {
        id: 'ml.gateway.quoteandbind.common.availableDocuments.View Spanish',
        defaultMessage: 'View Spanish'
    },
    et: {
        id: 'ml.gateway.quoteandbind.common.availableDocuments.ET',
        defaultMessage: 'ET'
    },
    ut: {
        id: 'ml.gateway.quoteandbind.common.availableDocuments.UT',
        defaultMessage: 'UT'
    },
})